'use client';

import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from 'reactstrap';

interface Attachment {
  media_id: string;
  attachment_id?: string;
  has_upload_completed?: boolean;
  image?: File;
  isImageUploading?: boolean;
}

interface ImagePreviewListingProps {
  onDeleteImage?: (mediaId: string) => void;
}

const ImagePreviewListing = ({ onDeleteImage }: ImagePreviewListingProps) => {
  const { watch, setValue } = useFormContext();

  const attachments = watch('attachments') as Attachment[] | undefined;
  const deletedAttachments = watch('deleted_attachments') as string[] | undefined;

  const handleDeleteImageClickHandler = useCallback((media: Attachment) => {
    const updatedAttachments = attachments?.filter(
      (attachment) => media?.media_id !== attachment?.media_id,
    );
    // keep track of deleted attachments
    if (media?.attachment_id && deletedAttachments && media?.has_upload_completed) {
      setValue('deleted_attachments', [...deletedAttachments, media?.attachment_id]);
    }

    setValue('attachments', updatedAttachments);
  }, [attachments, deletedAttachments, setValue]);

  return (
    attachments && attachments?.length > 0 ? (
      <div className="preview-image-wrapper">
        {attachments?.map((attachment) => {
          const imageUrl = attachment?.image ? URL.createObjectURL(attachment.image) : '';
          return (
            <div className="preview-image" key={attachment?.media_id}>
              <img
                src={imageUrl}
                alt="preview"
              />
              {attachment?.isImageUploading && (
              <div className="spinner-wrapper">
                <span className="spinner-border spinner-border-sm mr-2 d-block" />
              </div>
              )}
              <Button
                className="close-btn"
                onClick={() => {
                  if (attachment?.isImageUploading) {
                    onDeleteImage?.(attachment?.media_id);
                  }
                  handleDeleteImageClickHandler(attachment);
                }}
              >
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.33366 0.666565L0.666992 7.33323M0.666992 0.666565L7.33366 7.33323" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Button>
            </div>
          );
        })}

      </div>
    ) : ''
  );
};

export default ImagePreviewListing;
